export const TITLE = "Title";
export const OWNER = "Owner";
export const CREATED = "Created";
export const MODIFIED = "Modified";
export const PERMISSIONS = "Permissions";
export const LOCKED = "Locked";
export const STARRED = "Starred";
export const ACCESS = "Access";
export const ACTIONS = "Actions";
